import { render, staticRenderFns } from "./MetaDataModal.vue?vue&type=template&id=298bd222&scoped=true&"
import script from "./MetaDataModal.vue?vue&type=script&lang=js&"
export * from "./MetaDataModal.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataModal.vue?vue&type=style&index=0&id=298bd222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298bd222",
  null
  
)

export default component.exports